import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import qs from 'query-string'
import { Button, Icon } from 'semantic-ui-react'
import { getApiData, resetQuery } from 'helpers/api'
import { STAGE, DATASOURCE } from 'Constants'
import AccordionContent from './AccordionContent'
import CardWrapper from 'screens/common/CardWrapper'
import LineChart from 'components/LineChart'

class CallDetail extends Component {
  constructor(props) {
    super(props);
    let isData = 
          this.props.packetData.length === 2 && 
          (this.props.packetData[0].data.length > 0 || this.props.packetData[1].length > 0);
    this.state = {
      packetDataExists: isData,
    };
  }
  componentDidMount() {
    let querying = getApiData(DATASOURCE.DETAIL,this.props.location.search);
    if (querying) {
      resetQuery(DATASOURCE.PACKET_DATA_T, this.props.location.search);
      resetQuery(DATASOURCE.PACKET_DATA_S, this.props.location.search);
      resetQuery(DATASOURCE.LADDER, this.props.location.search);
      this.setState({packetDataExists:false});
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.callDetail.plcmTraceId && this.props.callDetail.plcmTraceId) {
      if (this.props.duration >= 120) {
        getApiData(this.props.isTeams ? DATASOURCE.PACKET_DATA_T : DATASOURCE.PACKET_DATA_S, this.props.location.search);
      }
    }
    if (prevProps.packetsLoading && !this.props.packetsLoading)
    {
      if (this.props.packetData.length === 2 && (this.props.packetData[0].data.length > 0 || this.props.packetData[1].length > 0)) {
        this.setState({packetDataExists: true});
      }
    }
  }

  returnToSender() {
    let myUrl = this.props.location.pathname.replace("/CallDetail",'');
    myUrl.replace(this.props.location.search,'');
    let params = qs.parse(this.props.location.search);
    delete params["callId"];
    this.props.history.push(myUrl + "?" + qs.stringify(params));
  }

  gotoLadder() {
    let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
    myUrl = myUrl.replace("CallDetail","CallLadder");
    this.props.history.push(myUrl + this.props.location.search);
  }

  render() {
    const { t } = this.props;
    let callId = this.props.callDetail.plcmTraceId ? this.props.callDetail.plcmTraceId : "Loading...";
    return (
      <div>
        <Button onClick={() => this.returnToSender()}><Icon name="undo"/> Return to List</Button>
        <h2>Call Detail [{callId}]</h2>
        <AccordionContent callDetail={this.props.callDetail} {...this.props} />
        {(this.state.packetDataExists || this.props.packetsLoading) &&
          <CardWrapper {...this.props}
            title={t("Screens.Calls.CallDetail.PacketChartTitle")}
            isLoading={this.props.packetsLoading}
           >
            <LineChart
              decimals={0}
              yAxisText={t("Screens.Calls.CallDetail.PacketChartY")}
              xAxisType="datetime"
              zoomType="x"
              series={this.props.packetData}
            />
          </CardWrapper>
        }
        {!(this.state.packetDataExists || this.props.packetsLoading) &&
          <p>No packet loss data for this call</p>
        }
        {this.props.callDetail.startTime && STAGE === "dev" &&
          Date.now() - Date.parse(this.props.callDetail.startTime) < 30*24*60*60*1000 &&
          <Button onClick={() => this.gotoLadder()}>Generate Call Ladder</Button>
        }
      </div>
    )
  }
}

// REDUX STATE
const mapToProps = state => {
  return {
    callDetail: state.callDetail.data,
    isTeams: state.callDetail.isTeams,
    duration: state.callDetail.duration,
    packetData: state.callDetail.isTeams ? state.packetDataT.data : state.packetDataS.data,
    packetsLoading: state.packetDataT.loading || state.packetDataS.loading
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(CallDetail)
);
